import React, { useContext } from "react";
import { Box, Illustration, Text } from "@mbank-design/design-system/components";
import { CrossMarkWomanMass } from "@mbank-design/design-system/illustrations";
import { LayoutView, UnorderedListView } from "../../components";
import { Context } from "../../context";

const invalidTokenError = "Nie możemy wyświetlić strony, ponieważ parametry przekazane w adresie url są nieprawidłowe... .";
const defaultError = "Nie możemy wyświetlić strony z powodu błędu.";
const texts = [
    "uruchomiłeś stronę wpisując jej bezpośredni adres",
    "przekazane parametry są nieprawidłowe",
    "wystapił inny, nieoczekiwany błąd"
]

export const ErrorPage = (): JSX.Element => {
    const state = useContext(Context);
    const [errorText, setErrorText] = React.useState<string>("");

    React.useEffect(() => {
        switch (state.appErrorState.type) {
            case "InvalidToken":
                setErrorText(invalidTokenError);
            break;
            default:
                setErrorText(defaultError);
            break;
        }
    }, [ state.appErrorState.type ]);

    return (
        <LayoutView>
            <Box maxWidth={520}>
                <Illustration illustrationComponent={CrossMarkWomanMass} size="100%"/>
            </Box>
            <Box>
                <Text as="h1" styledAs="h2">nie możemy...</Text>
            </Box>
            <Box>
                <Text>{errorText}</Text>
            </Box>
            {!state.appErrorState.type 
            ? <Box>
                <Text marginBottom={16}>Możliwe przyczyny:</Text>
                <UnorderedListView spacing={16} items={texts} />
            </Box> 
            : <></>}
        </LayoutView>
    );
}
